document.addEventListener("DOMContentLoaded", () => {
  const deliveryTimeThresholds = Object.values(
    window.themeVariables.settings.deliveryTimeThresholds
  );

  const deliveryTimer = document.querySelector("[data-delivery-time]");
  if (!deliveryTimer || !deliveryTimeThresholds) {
    return;
  }

  // Convert Date.getDay() (Sunday=0) to deliveryTimeThresholds index (Monday=0)
  const getThresholdIndex = (dateDay) => {
    // Date.getDay(): Sunday=0, Monday=1, Tuesday=2, ..., Saturday=6
    // deliveryTimeThresholds: Monday=0, Tuesday=1, ..., Sunday=6
    return dateDay === 0 ? 6 : dateDay - 1;
  };

  const findNextAvailableDay = (startDay) => {
    let i = startDay;
    let daysChecked = 0;
    let threshold = null;

    while (!threshold && daysChecked < 7) {
      i = (i + 1) % 7;
      threshold = deliveryTimeThresholds[i];
      daysChecked++;
    }

    return { threshold, daysChecked };
  };

  const getNextDeliveryTime = () => {
    const now = new Date();
    const thresholdIndex = getThresholdIndex(now.getDay());
    let threshold = deliveryTimeThresholds[thresholdIndex];
    let targetDate = new Date(now);
    let daysToAdd = 0;

    // If no threshold for today, find next available day
    if (!threshold) {
      const { threshold: nextThreshold, daysChecked } = findNextAvailableDay(thresholdIndex);
      
      if (!nextThreshold) {
        return null;
      }

      threshold = nextThreshold;
      daysToAdd = daysChecked;
    } else {
      // We have today's threshold, check if it has passed
      const [hours, minutes] = threshold.split(":");
      const todayThreshold = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hours,
        minutes,
        0
      );

      if (now >= todayThreshold) {
        // Today's threshold has passed, find next available day
        const { threshold: nextThreshold, daysChecked } = findNextAvailableDay(thresholdIndex);
        
        if (!nextThreshold) {
          return null;
        }

        threshold = nextThreshold;
        daysToAdd = daysChecked;
      }
    }

    // Create the final delivery time
    const [finalHours, finalMinutes] = threshold.split(":");
    return new Date(
      targetDate.getFullYear(),
      targetDate.getMonth(),
      targetDate.getDate() + daysToAdd,
      finalHours,
      finalMinutes,
      0
    );
  };

  const deliveryTime = getNextDeliveryTime();

  if (!deliveryTime) {
    deliveryTimer.remove();
    return;
  }

  if (deliveryTime.getDay() !== new Date().getDay()) {
    const day = deliveryTime.toLocaleDateString(window.themeVariables.settings.locale, {
      weekday: "long",
    });
    const time = deliveryTime.toLocaleTimeString(window.themeVariables.settings.locale, {
      hour: "2-digit",
      minute: "2-digit",
    });
    const deliveryNotice = window.themeVariables.strings.deliveryNoticeDay.replace(
      "@@",
      `<strong>${day} ${time}</strong>`
    );
    deliveryTimer.innerHTML = deliveryNotice;
    return;
  }

  const updateTimer = () => {
    const now = new Date();
    const timeDiff = deliveryTime - now;

    if (timeDiff <= 0) {
      const newDeliveryTime = getNextDeliveryTime();
      if (newDeliveryTime) {
        deliveryTime.setTime(newDeliveryTime.getTime());
      } else {
        clearInterval(intervalId);
        deliveryTimer.remove();
        return;
      }
    }

    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    // Get localized time unit abbreviations
    const timeUnits = window.themeVariables.strings.time;

    const timeString = `<strong>${hours}${timeUnits.hours} ${minutes
      .toString()
      .padStart(2, "0")}${timeUnits.minutes} ${seconds.toString().padStart(2, "0")}${timeUnits.seconds}</strong>`;

    const deliveryNotice = window.themeVariables.strings.deliveryNotice.replace("@@", timeString);
    deliveryTimer.innerHTML = deliveryNotice;
  };

  updateTimer();

  const intervalId = setInterval(updateTimer, 1000);

  const observer = new MutationObserver(() => {
    if (!document.contains(deliveryTimer)) {
      clearInterval(intervalId);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
